import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import UseChaseProvider from '../utils/use-chase-provider'
import { chaseItemDataTypes } from '../utils/data/chase-item-data'
import MessageDisplayCard from './message-display-card'

interface IChaseModel {
    children: React.ReactNode
}

const ChaseModel: React.FC<IChaseModel> = ({ children }) => {
    const { onSetChaseType, chaseType, chase, driverId } = UseChaseProvider()
    const chaseDetails = chaseItemDataTypes.find((chaseItemData) => chaseItemData.id === chaseType)

    return (
        <div className="w-full max-w-[520px] surface-card overflow-hidden animate-drop-in">

            {/* ------------------ [ HEADER ] ----------------------- */}

            <div className='w-full h-[68px] sm:h-[76px] grid grid-cols-[40px_1fr_40px] items-center gap-2 px-3 sm:px-5 border-b border-white/[0.12]'>
                <button type='button' aria-label='Back' onClick={() => onSetChaseType()} className='w-10 h-10 rounded-full flex items-center justify-center text-white bg-app-row border-[1.5px] border-[rgba(91,120,255,0.55)] hover:bg-[#16204A] active:scale-[0.96] transition-[background-color,transform] duration-[120ms]'>
                    <FontAwesomeIcon icon={faArrowLeft} />
                </button>
                <h2 className='min-w-0 text-title sm:text-[20px] text-white m-0 p-0 flex items-center justify-center gap-2 text-center'>{chaseDetails?.label} <span className='text-[24px] sm:text-[26px] leading-none flex items-center justify-center' aria-hidden>{chaseDetails?.desc.split(" ").pop()}</span></h2>
                <span />
            </div>

            {/* ------------------ [ HEADER ] ----------------------- */}

            <div className='px-4 py-6 sm:p-8'>
                {(chase?.chaseItem?.find((chaseItm) => chaseItm?.type === chaseType)?.status === "Rejected" || chase?.drivers?.find((driver) => driver.id === driverId)?.chaseItem?.find((driverChaseItm) => driverChaseItm.type === chaseType)?.status === "Rejected") && <div className='mb-6'>
                    <MessageDisplayCard showReply={true} />
                </div>}
                {children}
            </div>
        </div>
    )
}

export default ChaseModel
